import React from "react"

import {values} from "lodash"
import PropTypes from "prop-types"
import {Field, Form, reduxForm} from "redux-form"
import {Icon, Input, Form as SemanticForm} from "semantic-ui-react"

import {required} from "../../services/validation"
import {normalizeNoSpace} from "../../services/normalizeString"
import ButtonPrimary from "../ButtonPrimary/buttonPrimary"
import PasswordField from "../PasswordField/passwordField"
import SemanticFormField from "../SemanticFormField/semanticFormField"
import texts from "./texts.js"

import "./login.scss"

export const LOGIN_VARIANTS = {DEFAULT: "default", NEW: "new"}

const Login = ({
    errorMessage,
    handleSubmit,
    isFetching,
    links,
    onSubmit,
    usernameLabel = texts.sharedLoginIdentifiant,
    variant = LOGIN_VARIANTS.DEFAULT,
}) => {
    return (
        <SemanticForm
            aria-label="Formulaire de connexion"
            as={Form}
            className={`login variant-${variant}`}
            onSubmit={handleSubmit(onSubmit)}
        >
            {variant === LOGIN_VARIANTS.DEFAULT && (
                <p className="login-question">
                    <Icon aria-hidden="true" className="fa-solid fa-caret-right" />
                    <b>{texts.sharedLoginParagraph}</b>
                    {texts.sharedLoginParagraph2}
                </p>
            )}

            {errorMessage && (
                <div aria-live="polite" className="login-error-message" role="alert">
                    {errorMessage}
                </div>
            )}

            <Field
                as={Input}
                autoComplete="username"
                component={SemanticFormField}
                fluid
                htmlLabel={<label>{usernameLabel}</label>}
                name="login"
                normalize={normalizeNoSpace}
                validate={required}
            />

            <PasswordField
                as={Input}
                autoComplete="current-password"
                component={SemanticFormField}
                fluid
                htmlLabel={<label>{texts.passwordPlaceholder}</label>}
                name="password"
                validate={required}
                withFaIcons={true}
            />

            <ButtonPrimary actionType="submit" disabled={isFetching} fluid loading={isFetching}>
                {texts.sharedLoginButton}
            </ButtonPrimary>

            {links && <div className="login-links">{links}</div>}
        </SemanticForm>
    )
}

Login.propTypes = {
    errorMessage: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    links: PropTypes.node,
    onSubmit: PropTypes.func.isRequired,
    usernameLabel: PropTypes.string,
    variant: PropTypes.oneOf(values(LOGIN_VARIANTS)),
}

export default reduxForm({form: "loginForm"})(Login)
